import { render } from "./NewsletterCard.vue?vue&type=template&id=f395d21a&scoped=true"
import script from "./NewsletterCard.vue?vue&type=script&lang=js"
export * from "./NewsletterCard.vue?vue&type=script&lang=js"

import "./NewsletterCard.vue?vue&type=style&index=0&id=f395d21a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f395d21a"

export default script